import { createAction, props } from '@ngrx/store';
import { ErrorInterface } from '../../interfaces/general.interface';
import {
  AuthUserEntityInterface,
  LoginCodeInterface,
  LoginInterface,
  ResponseLoginInterface,
} from '../../interfaces/auth.interface';

enum LoginCodeActionType {
  loginCode = '[login code] login code',
  requestSuccess = '[login code] success login code',
  requestError = '[login code] error login code',
  clearLoginCode = '[login code] clear login code',
}

export const loginCode = createAction(
  LoginCodeActionType.loginCode,
  props<{ params: LoginCodeInterface }>()
);

export const requestSuccess = createAction(
  LoginCodeActionType.requestSuccess,
  props<{ response: AuthUserEntityInterface }>()
);

export const requestError = createAction(
  LoginCodeActionType.requestError,
  props<{ error: ErrorInterface }>()
);

export const clearLoginCode = createAction(LoginCodeActionType.clearLoginCode);
